import React from 'react';
import PropTypes from 'prop-types';
import CurrencyInput from 'react-currency-input-field';

import Wrap from './styles';

const Budget = ({ onChange }) => {
  return (
    <Wrap>
      <div className="_spectrum-Field_36b9b _spectrum-Field--positionTop_36b9b">
        <label className="_spectrum-FieldLabel_36b9b">Budget</label>
        <CurrencyInput
          // prefix="$ "
          placeholder="$ 0.00"
          decimalsLimit={2}
          onValueChange={value => onChange(value)}
        />
      </div>
    </Wrap>
  );
};

Budget.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default Budget;
